import React, { useEffect, useState } from "react";
import styles from "./groupAssets.module.css";
import Card from "../../../../components/Card/Card";
import { Modal, TextComponent } from "../../../../components";
import AddGroupAssetModal from "../AddGroupAsset/AddGroupAsset";
import ScheduleModal from "../ScheduleModal/ScheduleModal";
import EditScheduleModal from "../ScheduleModal/EditScheduleModal";
import { FiPlusCircle } from "react-icons/fi";
import { Button, Dropdown, List } from "antd";
import md1 from "../../../../assets/images/staticImages/c1.png";
import md2 from "../../../../assets/images/staticImages/c2.png";
import md3 from "../../../../assets/images/staticImages/c3.png";
import md4 from "../../../../assets/images/staticImages/c4.png";
import c6 from "../../../../assets/images/staticImages/c6.png";
import { SlOptionsVertical } from "react-icons/sl";
import Switch from "../../../../components/Switch/Switch";
import { MdMyLocation } from "react-icons/md";
import { AiFillPlusCircle, AiOutlineQuestionCircle } from "react-icons/ai";
import EditAssets from "../EditAsset/EditAsset";
import TrackingModal from "../TrackingModal/TrackingModal";
import { PiSealCheck } from "react-icons/pi";
import AddNewGroupAssetModal from "../AddGroupAsset/AddNewGroupAsset";
import EditGroupAssetModal from "../EditGroupAsset/EditGroupAsset";
import { AssetsMiddleware } from "../../../../Store/Middlewares/AssetsMiddleware";
import { useDispatch, useSelector } from "react-redux";
import imagePlaceholder from "../../../../assets/images/imageplace.jpg";
import GroupEditSchedule from "./ScheduleModal/GroupEditSchedule";
import GroupSchedule from "./ScheduleModal/GroupSchedule";
import { ScheduleMiddleware } from "../../../../Store/Middlewares/ScheduleMiddleware";
import { extractBytes, hexToBase64 } from "../../../../utills";
import {
  group_assets_details,
  set_status_of_group_asset,
  setAssetStatus,
} from "../../../../Store/Actions/AssetsAction";
import GroupAssetDetails from "./GroupDetails/Groupdetails";
const items = [
  {
    key: "1",
    label: (
      <a
      // target="_blank"
      // rel="noopener noreferrer"
      // href="https://www.antgroup.com"
      >
        Edit details
      </a>
    ),
  },
  {
    key: "2",
    label: (
      <a
      // target="_blank"
      // rel="noopener noreferrer"
      // href="https://www.aliyun.com"
      >
        Delete groug
      </a>
    ),
  },
];

const GroupAssets = ({
  add_asset,
  is_immobilized,
  user,
  group_immobilizer,
  groupAssetDetail,
  setGroupAssetDetail,
}) => {
  const dispatch = useDispatch();
  const [openEditAssetsModal, setOpenEditAssetsModal] = useState(false);
  const [locationTracking, setLocationTracking] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [success, setSuccess] = useState(false);
  const [openAddGroupAsset, setOpenAddGroupAsset] = useState(false);
  const [openEditGroupAsset, setOpenEditGroupAsset] = useState(false);
  const [openAddNewGroupAsset, setOpenAddNewGroupAsset] = useState(false);
  const [scheduleModal, setScheduleModal] = useState(false);
  const [editScheduleModal, setEditScheduleModal] = useState(false);
  const [schedule, setScheduleData] = useState(null);

  const GroupAssets = useSelector(
    (state) => state.AssetsReducer.getGroupAssets,
  );
  const GroupAssetDetail = useSelector(
    (state) => state.AssetsReducer.groupAssetDetails,
  );

  const lot_lockdown_control = user?.permissions?.find(
    (x) => x?.name == "group_immobilizer",
  );
  const [assetDetails, setAssetdetails] = useState();

  // useEffect(() => {
  //   dispatch(AssetsMiddleware.getAssetGroup()).then((data) => {
  //     const firstGroup = data?.data?.data[0];
  //     group_assets_details(firstGroup);
  //   });
  // }, []);

  useEffect(() => {
    if (GroupAssetDetail) {
      setAssetdetails(GroupAssetDetail.assets?.[0]);
    }
  }, [GroupAssetDetail]);

  useEffect(() => {
    if (assetDetails) {
      dispatch(
        set_status_of_group_asset({
          device_id: assetDetails?.device_id,
          status: assetDetails?.status,
        }),
      );
    }
  }, [assetDetails]);

  const onClickGroupMainImmobilized = (data) => {
    dispatch(
      AssetsMiddleware.sentGroupDownlink({
        group_id: data?.id,
        action: data?.status != "immobilized" ? "A1" : "A2",
        status: data?.status == "immobilized" ? "drive" : "immobilized",
      }),
    );
  };

  const onClickGetDetail = (id) => {
    dispatch(AssetsMiddleware.getAssetsGroupDetails(id)).then((data) => {
      group_assets_details(data?.data?.data);
      setGroupAssetDetail(data?.data?.data);
    });
  };

  const renderItem = (item) => {
    return (
      <div
        className={`
          ${styles.subcont} 
        ${GroupAssetDetail?.id == item?.id ? styles.active : ""}`}
        onClick={() => onClickGetDetail(item?.id)}
        key={item?.id}
      >
        <TextComponent
          text={item?.name}
          className={`${styles.heading} ${GroupAssetDetail?.id == item?.id ? styles.textactive : ""}`}
        />
        <div
          className={styles.mobStatusCont}
          onClick={(e) => e.stopPropagation()}
        >
          {user?.is_owner || group_immobilizer?.is_access == 1 ? (
            <Switch
              initialChecked={item?.status == "immobilized" ? true : false}
              isChecked={item?.status == "immobilized" ? true : false}
              onChange={(e) => {
                onClickGroupMainImmobilized(item);
              }}
              size="small"
              // disabled={is_immobilized?.is_access == 0 || !user?.is_owner }
            />
          ) : null}
          <TextComponent
            text={item?.status == "drive" ? "Drive" : "Immobilized"}
            className={styles.text}
          />
        </div>
      </div>
    );
  };

  return (
    <div className={styles.mainCont}>
      {groupAssetDetail !== null ? (
        <GroupAssetDetails
          is_immobilized={is_immobilized}
          group_immobilizer={group_immobilizer}
          add_asset={add_asset}
          user={user}
          group_data={groupAssetDetail}
          setGroupAssetDetail={setGroupAssetDetail}
        />
      ) : (
        <Card className={styles.card}>
          <div className={styles.header}>
            {GroupAssetDetail && (
              <TextComponent text={"vehicles"} className={styles.heading} />
            )}
            {user?.is_owner || lot_lockdown_control?.is_access == 1 ? (
              <div
                className={styles.btn}
                onClick={() => setOpenAddGroupAsset(true)}
              >
                <TextComponent text={"Add Group"} />
                <FiPlusCircle size={18} style={{ marginLeft: "5px" }} />
              </div>
            ) : null}
          </div>

          <List dataSource={GroupAssets?.data} renderItem={renderItem} />
        </Card>
      )}
      <EditAssets
        isOpen={openEditAssetsModal}
        setIsOpen={setOpenEditAssetsModal}
      />
      <TrackingModal
        locationTracking={locationTracking}
        setLocationTracking={setLocationTracking}
        assets={[1, 2, 3, 4]}
      />
      {/* <AddAssets
        isOpen={openAddAssetsModal}
        setIsOpen={setOpenAddAssetsModal}
      /> */}
      <AddGroupAssetModal
        isOpen={openAddGroupAsset}
        setIsOpen={setOpenAddGroupAsset}
      />

      <EditGroupAssetModal
        isOpen={openEditGroupAsset}
        setIsOpen={setOpenEditGroupAsset}
        details={GroupAssetDetail}
      />
      <AddNewGroupAssetModal
        isOpen={openAddNewGroupAsset}
        setIsOpen={setOpenAddNewGroupAsset}
      />
      <GroupSchedule
        scheduleModal={scheduleModal}
        setScheduleModal={setScheduleModal}
        details={GroupAssetDetail}
      />
      <GroupEditSchedule
        scheduleModal={editScheduleModal}
        setScheduleModal={setEditScheduleModal}
        details={GroupAssetDetail}
        scheduleData={schedule}
      />

      <Modal
        open={deleteModal}
        onCancel={() => {
          setDeleteModal(false);
        }}
        icon={
          <AiOutlineQuestionCircle
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        twoButton
        okBtnTitle={"Yes, delete"}
        cancelBtnTitle={"No, go back"}
        title={"Are you sure"}
        text={"You want to delete this Group?"}
        width={400}
        // btnDiv={styles.access_modalBtn}
        onClickCancelButton={() => {
          setDeleteModal(false);
        }}
        onClickOkButton={() => {
          dispatch(
            AssetsMiddleware.deleteAssetGroup(GroupAssetDetail?.id),
          ).then(() => {
            setSuccess(true);
            setDeleteModal(false);
            // if(GroupAssets?.length != 0){
            //   setGroupAssetDetail(GroupAssets[0])
            // }else{
            //   setGroupAssetDetail()
            // }
          });
        }}
        headingClass={styles.modalHeading}
      ></Modal>
      <Modal
        open={success}
        onCancel={() => setSuccess(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Group Deleted successfully"}
        width={"300px"}
        buttonTitle={"Continue"}
        onBtnPress={() => {
          setSuccess(false);
        }}
        headingClass={styles.modalHeading}
      ></Modal>
    </div>
  );
};

export default GroupAssets;
